import { useEffect, useRef, useState } from 'react';

export default function HeroSculpture({ enabled, fallback }) {
  const host = useRef(null);
  const scene = useRef(null);
  const enabledRef = useRef(enabled);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    enabledRef.current = enabled;
    scene.current?.setMotion(enabled);
  }, [enabled]);
  useEffect(() => {
    let cancelled = false;
    import('./heroScene').then(({ createHeroScene }) => {
      if (cancelled) return;
      try {
        scene.current = createHeroScene(host.current, enabledRef.current, () => setReady(false));
        setReady(true);
      } catch { setReady(false); }
    }).catch(() => setReady(false));
    return () => { cancelled = true; scene.current?.dispose(); scene.current = null; };
  }, []);
  return <div className={'hero-three ' + (ready ? 'is-ready' : '')}>
    <div className="hero-three-aura" aria-hidden="true" />
    <div ref={host} className="hero-three-canvas" role="img" aria-label="ひとつの緑の土台から枝分かれし、教育を表す本、Webを表すブラウザ画面、フィジカルAIを表すロボットアームにつながる3Dオブジェクト" />
    <div hidden={!ready} className="foundation-labels" aria-hidden="true"><span className="foundation-label">EDUCATION</span><span className="foundation-label">WEB</span><span className="foundation-label">PHYSICAL AI</span></div>
    {!ready && <div className="hero-three-fallback">{fallback}</div>}
    <div className="hero-three-caption"><span>DIFFERENT FIELDS. SAME FOUNDATION.</span><p>共通の土台は、現場の声</p><small>聞く · 課題をほどく · 使って確かめる</small></div>
  </div>;
}
